// *** NPM ***
import React, {createContext, useContext, useState} from 'react';

// *** OTHER ***
import Notice, {IError} from '../components/Notice/Notice';

interface IContextProps {
    handleSuccessNotification: (result?: any) => boolean;
    handleErrorNotification: (result?: any) => boolean;
    handleCloseSnackbar: (event?: React.SyntheticEvent, reason?: string) => void;
}

export const NotificationContext = createContext<IContextProps | null>(null);

const NotificationContextProvider = (props: any) => {
    const {logout} = props;
    // *** STATES ***
    const [isNoticeOpen, setNoticeOpen] = useState<boolean>(false);
    const [responseStatus, setResponseStatus] = useState<IError>({
        status: '',
        message: '',
        codeError: null,
    });
    // *** THIS FUNK HANDLES SUCCESSFUL RESPONSES ***
    const handleSuccessNotification = (result?: any): boolean => {
        const {message} = result.data;
        setResponseStatus({...responseStatus, status: 'success', message, codeError: null});
        setNoticeOpen(true);
        return true;
    };

    // *** THIS FUNK HANDLES ERROR RESPONSES ***
    const handleErrorNotification = (result: any, showSuccess: boolean = false): boolean => {
        if (result?.message === 'Network Error' || typeof result === 'undefined') {
            setResponseStatus({
                ...responseStatus,
                status: 'error',
                message: 'Ошибка подключения',
            });
            setNoticeOpen(true);
        } else {
            switch (result?.data?.error) {
                case 0: {
                    if (showSuccess) {
                        setResponseStatus({
                            ...responseStatus,
                            status: 'success',
                            message: result.data.message ?? null,
                            codeError: null,
                        });
                        setNoticeOpen(true);
                    }
                    break;
                }
                case -3: {
                    setResponseStatus({
                        ...responseStatus,
                        status: 'error',
                        message: result.data.error_description,
                        codeError: result.data.error,
                    });
                    setNoticeOpen(true);
                    logout();
                    break;
                }
                default:
                    setResponseStatus({
                        ...responseStatus,
                        status: 'error',
                        message: result.data.error_description,
                        codeError: result.data.error,
                    });
                    setNoticeOpen(true);
            }
        }
        return false;
    };

    // *** HANDLE CLOSE SNACK BAR FUNCTION
    const handleCloseSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
        setNoticeOpen(false);
    };

    return (
        <NotificationContext.Provider value={{handleSuccessNotification, handleErrorNotification, handleCloseSnackbar}}>
            {props.children}
            <Notice responseStatus={responseStatus} isSnackbarOpen={isNoticeOpen} handleCloseSnackbar={handleCloseSnackbar} />
        </NotificationContext.Provider>
    );
};

export {NotificationContextProvider};

export default function CallNotification(): any {
    return useContext(NotificationContext);
}
